/**
 * Wave 5 (Slice C M-05) — the ONE CSV cell formatter for every export.
 *
 * Two jobs:
 *  1. Correct quoting: wrap in double quotes, double any embedded quotes.
 *  2. Formula-injection neutralisation: spreadsheet apps execute a cell
 *     whose first meaningful character is `=`, `+`, `-`, `@`, TAB or CR
 *     as a formula. Applicant-controlled strings (names, employers,
 *     free-text answers) flow into admin exports, so a leading formula
 *     character is prefixed with an apostrophe, which spreadsheet apps
 *     render as a literal leading `'` marker and never evaluate.
 *
 * Every exporter — client and server — must build cells through here
 * instead of a local escapeCsv (the local copies historically only did
 * job 1, and one server copy did not even double embedded quotes).
 */
export function csvCell(value: unknown): string {
  const s = value === null || value === undefined ? '' : String(value);
  const firstMeaningful = s.replace(/^[\s﻿]+/, '').charAt(0);
  const dangerous = firstMeaningful === '=' || firstMeaningful === '+'
    || firstMeaningful === '-' || firstMeaningful === '@'
    || firstMeaningful === '\t' || firstMeaningful === '\r';
  const body = dangerous ? `'${s}` : s;
  return `"${body.replace(/"/g, '""')}"`;
}

export function csvRow(values: unknown[]): string {
  return values.map(csvCell).join(',');
}
